<div class="p-3">
  <h5>Crea una nuova cartella</h5>

  <form [formGroup]="newFolderForm" class="mt-3">
    <mat-form-field appearance="outline" class="w-100">
      <mat-label>Nome cartella</mat-label>
      <input
        matInput
        type="text"
        id="nome_cartella"
        name="nome_cartella"
        class="form-control"
        formControlName="nome_cartella"
      />
    </mat-form-field>
    <mat-error>
      <div
        class="text-danger d-block"
        *ngIf="newFolderForm.get('nome_cartella').touched && newFolderForm.get('nome_cartella').errors"
      >
        <small *ngIf="newFolderForm.get('nome_cartella').errors.required"> Il campo è obbligatorio </small>

        <ng-container *ngIf="newFolderForm.get('nome_cartella').errors as errors">
          <small *ngIf="errors.folderExists"> Nome cartella già esistente </small>

          <small *ngIf="errors.pattern?.requiredPattern">
            Il nome del file non può contenere caratteri speciali come \, /, :, *, ?, ", <, >, |
          </small>
        </ng-container>
      </div>
    </mat-error>
  </form>

  <div class="d-flex aling-items-center justify-content-end gap-2 mt-3">
    <button mat-button type="button" class="btn btn-bg-outline" (click)="close()">Annulla</button>
    <button mat-flat-button [disabled]="newFolderForm.invalid" type="button" class="btn" (click)="confirm()">
      Conferma
    </button>
  </div>
</div>
